import { Environment } from 'config/environment'
import i18n from 'modules/core/lib/i18n'

const i18nInitializer = (environment: Environment) => {
  i18n.raiseI18nExceptions = environment.raiseI18nExceptions
}

export default i18nInitializer
